@if (visible()) {
  <div class="so-toast" [class]="'so-toast--' + type() + ' ' + positionClass()" role="status">
    <div class="so-toast__icon">
      <so-svg-icon-ui [name]="icon()" [size]="18" [color]="iconColor()"></so-svg-icon-ui>
    </div>
    <span class="so-toast__message">{{ message() }}</span>
    <button type="button" class="so-toast__close" (click)="dismiss()" aria-label="Cerrar">
      <so-svg-icon-ui [name]="'close'" [size]="16" [color]="'--so-gray-thick'"></so-svg-icon-ui>
    </button>
  </div>
}
